import React, {Component} from 'react';
import {Menu, Segment} from 'semantic-ui-react';
import SideNavInternal from 'go/components/dynamic/layout/SideNavInternal';
import _ from 'lodash';
import {HOME} from 'app-ui-componentlibrary/dist/go/components/common/pageTitles';
import {connect} from 'react-redux';

export class DynamicSideNav extends Component {
  componentDidUpdate() {
    let hash = this.props.hash;
    if (hash) {
      hash = hash.replace(/[&\/\\#,+()$~%.'":*?<>{}0-9]/g, ' ');
      // On Application, when clicking children items under Grant request details
      // the hash used for the page title looks like #item-1-children-uuid-string
      // Here if the hash contains 'children', we'll assign the page title in
      // RequestDetailsSideNav.js child menu item in the <Menu.Item onClick
      if (hash.indexOf('children') === -1) {
        document.title = `${HOME} - ${hash}`;
      }
    }
  }

  render() {
    return (
      <Segment.Group className="sideNavSegment" vertical="true" basic="true">
        <Menu className="side-nav-menu" vertical borderless>
          <SideNavInternal {...this.props} />
        </Menu>
      </Segment.Group>
    );
  }
}

export const mapStateToProps = (state) => {
  let props = {
    hash: state.router.location.hash,
  };
  return props;
};

export default connect(mapStateToProps)(DynamicSideNav);
